var _path, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1174 7.01493L9.37406 7.55706L10.2333 7.88588C12.5918 8.78841 14.2691 11.0749 14.2691 13.7436C14.2691 14.7116 13.4808 15.5 12.5127 15.5H3.48712C2.51907 15.5 1.73071 14.7116 1.73071 13.7436C1.73071 11.0749 3.40806 8.78841 5.76654 7.88588L6.62582 7.55706L5.88246 7.01493C4.98165 6.35798 4.39737 5.29679 4.39737 4.10256C4.39737 2.11655 6.01392 0.5 7.99993 0.5C9.98595 0.5 11.6025 2.11655 11.6025 4.10256C11.6025 5.29678 11.0182 6.35798 10.1174 7.01493ZM14.0384 13.7436V13.7436C14.0384 10.4135 11.3301 7.70509 7.99996 7.70509C4.66985 7.70509 1.96149 10.4135 1.96149 13.7436C1.96149 14.5853 2.64544 15.2692 3.48712 15.2692H12.5127C13.3545 15.2692 14.0384 14.5853 14.0384 13.7436ZM7.99993 0.730781C6.14029 0.730781 4.62815 2.24292 4.62815 4.10256C4.62815 5.9622 6.14028 7.47437 7.99993 7.47437C9.85958 7.47437 11.3717 5.9622 11.3717 4.10256C11.3717 2.24292 9.85957 0.730781 7.99993 0.730781Z",
    fill: "white",
    stroke: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 14.5,
    x2: 14,
    y2: 14.5,
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.4d2f0b50ded64639cdbae9ad8c89630f.svg";
export { ForwardRef as ReactComponent };